import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { StartPage } from "../pages/start-page/start-page";
import { Suspense } from "react";
import { LoginPage } from "../pages/login-page/login-page";
import { StoriesPage } from "../pages/stories-page/stories-page";
import { links } from "./links";
import { StepPage } from "../pages/step-page/step-page";
import { RegPage } from "../pages/reg-page/reg-page";
import { PolicyPage } from "../pages/policy-page/policy-page";
import { RulesPage } from "../pages/rules-page/rules-page";
import { ProfilePage } from "../pages/profile-page/profile-page";
import { RecoveryPasswordPage } from "../pages/recovery-password-page/recovery-password-page";
import { FeedbackPage } from "../pages/feedback-page/feedback-page";
import { ErrorPage } from "../pages/error-page/error-page";
import { ProfileInfoPage } from "../pages/profile-info-page/profile-info-page";
import { InstructionPage } from "../pages/instruction-page/instruction-page";

const AppRouter = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <StartPage />,
    },
    {
      path: links.login,
      element: <LoginPage />,
    },
    {
      path: links.reg,
      element: <RegPage />,
    },
    {
      path: links.stories,
      element: <StoriesPage />,
    },
    {
      path: links.step + "/:id",
      element: <StepPage />,
    },
    {
      path: links.policy,
      element: <PolicyPage />,
    },
    {
      path: links.rules,
      element: <RulesPage />,
    },
    {
      path: links.profile,
      element: <ProfilePage />,
    },
    {
      path: links.profileInfo,
      element: <ProfileInfoPage />,
    },
    {
      path: links.recoveryPassword,
      element: <RecoveryPasswordPage />,
    },
    {
      path: links.feedback,
      element: <FeedbackPage />,
    },
    {
      path: links.instruction,
      element: <InstructionPage />,
    },
    {
      path: "*",
      element: <ErrorPage />,
    },
  ]);

  // return (
  //   <Suspense fallback={<BigLoader />}>
  //     <RouterProvider router={router} />
  //   </Suspense>
  // );

  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default AppRouter;
